// extracted by mini-css-extract-plugin
module.exports = {"UserData":"SampleSolution_UserData__2y0NT"};